import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findShipmentList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/delivery-order?` + params,
        method: 'GET'
    })
}
export const findShipmentListExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/shipmentExcel?` + params,
        method: 'GET'
    })
}
export const findProductGoodsList = () => {
    return request({
        url: `${baseUrl}/joins-product/v1/product/all`,
        method: 'GET'
    })
}
export const v2ProductSelect = () => {
    return request({
        url: `${baseUrl}/joins-product/v2/product/select`,
        method: 'GET'
    })
}

export const addShipment = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/addShipment`,
        method: 'POST',
        data: data
    })
}
//删除出货单
export const deleteShipment = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/delivery-order/${id}`,
        method: 'DELETE'
    })
}
export const addShipment2 = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/addShipment2`,
        method: 'POST',
        data: data
    })
}
export const findShipmentById = (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/shipmentDetail/${id}`,
        method: 'GET'
    })
}
export const updateShipment = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/updateShipment`,
        method: 'PUT',
        data: data
    })
}
export const send = (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/send/${id}`,
        method: 'GET'
    })
}

export const engineerGoodsSelect = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/put/goods?`+params,
        method: 'GET'
    })
}
export const findProductGoodsById= (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/put/goods/${id}`,
        method: 'GET'
    })
}
export const addEngineerShipment = (data) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/delivery-order`,
        method: 'POST',
        data: data
    })
}
